
import Component from "vue-class-component"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import LifeInsuranceChart from "@/superannuation/LifeInsuranceChart.vue"
import AnimatedNumber from "@/ui/AnimatedNumber.vue"
import SsComponentPage from "@/report/pages/SsComponentPage.vue"

@Component({
  name: "SsInsurancePage",
  components: {
    SsComponentPage,
    LifeInsuranceChart,
    AnimatedNumber,
  },
})
export default class SsInsurancePage extends AbstractPage {
  get insuranceIndicatorCompleted() {
    return this.metricStore.get(this.$metrics.MemberSnapshot.countMembers, {
      [this.$cubes.MemberSnapshotCube.insuranceIndicatorCompleted]: "1|Yes",
    }).end?.amount
  }
}
